<template>
  <b-container fluid id="form-container">
    <b-row>
      <b-col>
        <h1>Contacts</h1>

        <div>
          <b-row>
            <AppNav :applicationId="appId"></AppNav>
          </b-row>
          <b-form id="pgContainer" tabindex="-1">
            <div class="card" v-if="application">
              <div class="card">
                <div class="card-header">Application Info</div>
                <div class="card-body">
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Program:</span> {{ application.appName.programNm }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Application Type:</span> {{ application.appName.applicationTypeNm }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Application Sub Type:</span> {{ application.appName.applicationSubTypeNm }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Application Number:</span> {{ application.applicationNumber }}</b-col>
                  </b-row>
                </div>
              </div>
              <div class="card-header">Follow Up Contact Information</div>
              <div class="card-body">
                <b-toast id="minToast" static no-close-button :visible="!$v.contacts.minLength || !$v.contacts.required" no-auto-hide
                         role="alert" variant="danger" class="w-100 max-width">
                  At least {{$v.contacts.$params.minLength.min}} contact(s) are required!
                </b-toast>
                <div v-for="(contact, index) in contacts" :key="index">
                  <b-row>
                    <b-col cols="6">
                      <BaseTextInput v-model="contact.lastName"
                                     :v="$v.contacts.$each[index].lastName"
                                     slug="lastName"
                                     label="Last Name"
                                     :setId="'contactLastName'+index"
                      />
                    </b-col>
                    <b-col cols="6">
                      <BaseTextInput v-model="contact.firstName"
                                     :v="$v.contacts.$each[index].firstName"
                                     slug="firstName"
                                     label="First Name"
                                     :setId="'contactFirstName'+index"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="5">
                      <BaseMaskedTextInput v-model="contact.phone"
                                           :v="$v.contacts.$each[index].phone"
                                           slug="phone"
                                           label="Phone"
                                           :setId="'contactPhone'+index"
                                           mask="###-###-####"
                      />
                    </b-col>
                    <b-col cols="5">
                      <BaseTextInput v-model="contact.email"
                                     :v="$v.contacts.$each[index].email"
                                     slug="email"
                                     label="Email"
                                     :setId="'contactEmail'+index"
                      />
                    </b-col>
                    <b-col cols="2" class="d-flex align-items-center justify-content-center">
                      <b-button type="button" variant="outline-secondary" @click="removeContact(index)">remove</b-button>
                    </b-col>
                  </b-row>
                </div>
                <b-row v-if="contacts.length < $v.contacts.$params.maxLength.max">
                  <b-col>
                    <b-button variant="outline-primary" size="sm" @click="addContact()">
                      Add Another Contact
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </div>
            <b-row class="float-right">
              <b-col>
                <b-button type="button" variant="secondary" to="/dashboard" role="button" class="mr-1">Cancel</b-button>
                <b-button type="button" variant="success" class="mr-1" @click="saveApplication">Save Contact(s)</b-button>
                <b-button type="button" variant="primary" class="mr-1" @click="saveApplicationContinue">Save & Continue</b-button>
                <b-button @click="submitApplication" variant="primary" class="mr-1">
                  Submit Application
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import axios from 'axios'
  import axiosRetry from 'axios-retry'
  import { required, requiredIf, maxLength, minLength, email } from 'vuelidate/lib/validators'
  import router from "@/router";
  import ConfigService from "@/services/ConfigService";
  import AppNav from "@/components/templates/AppNav";

  axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  })

export default {
  components: {AppNav},
  data: () => ({
    appId: null,
    application: null,
    contacts: [{
      lastName: null,
      firstName: null,
      phone: null,
      email: null
    }],
    min: null,
  }),

  created() {
    document.title = "Contacts - Facility and Provider Licensing System"
    this.appId = this.$route.params.id
    this.loadApplication()
    this.loadContacts()
    this.min = this.$v.contacts.$params.minLength.min
  },
  mounted() {
    document.getElementById('pgContainer').focus()
  },
  methods: {
    loadApplication() {
      axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId)
      .then(response => {
        this.application = response.data
      })
    },
    loadContacts() {
      axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + '/contacts')
      .then(response => {
        if(response.data.length > 0) {
          this.contacts = response.data
          this.application.contacts = response.data
        }
      })
    },
    saveApplication() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$nextTick(() => {
          document.getElementById('form-container').scrollIntoView()
        })
        return
      }
      if (this.contacts.length > 0) {
        this.contacts.forEach((contact, index) => {
          if (contact.id && this.application.contacts && this.application.contacts.some(c => c.id === contact.id)) {
            axios.put(ConfigService.getApiUrl() + `/api/applications/`+this.application.id + '/contacts/' + contact.id, contact)
              .then(response => {
                if (index === this.contacts.length-1) {
                  this.showRootToast("Saved", "Application saved", "success")
                }
            })
          } else {
            axios.post(ConfigService.getApiUrl() + `/api/applications/`+this.application.id + '/contacts', contact)
              .then(response => {
                if (index === this.contacts.length-1) {
                  this.showRootToast("Saved", "Application saved", "success")
                }
            })
          }
        })
      } else {
        this.showRootToast("Saved", "Application saved", "success")
      }
    },
    saveApplicationContinue() {
      this.saveApplication()
      if (!this.$v.$invalid) {
        setTimeout(() => {
          router.push("/attachments/" + this.appId)
        }, 200)

      }
    },
    submitApplication() {
      this.saveApplication()
      axios.post(ConfigService.getApiUrl() + `/api/applications/` + this.appId + '/submit')
        .then(response => {
          this.showRootToast("Submitted", "Application successfully submitted", "success")
          setTimeout(() => {
            router.push("/dashboard")
          }, 200)
        }).catch(err => {
            if (err.response) {
              let errorList = Object.values(err.response.data)
              this.showRootToast("Error", this.createErrorToast(errorList),
                      "danger")
            } else {
              this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                      "danger")
            }
        })
    },

    addContact() {
      this.contacts.push({
        lastName: null,
        firstName: null,
        phone: null,
        email: null
      });
    },

    removeContact(idx) {
      this.$delete(this.contacts, idx)
    },

    createErrorToast(errors) {
      const h = this.$createElement
      const errNodes = h(
        'div',
        [
          h('p','Application contains errors, please fix and resubmit'),
          h('ul', [
            errors.map(e => {
              return h('li', {attrs:{class: 'circle-list ml-4'}}, e)
            })
          ])
        ]
      )
      return errNodes
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true,
        noAutoHide:true
      })
      this.toastFocus()
    },
    toastFocus() {
      setTimeout(() => {
        let elem = document.getElementsByClassName("toast")
        elem = elem[elem.length-1]
        elem.focus()
      }, 100)
    },
  },

  validations() {
    return {
      contacts: {
        required: requiredIf(function() { return this.min > 0 }),
        minLength: minLength(0),
        maxLength: maxLength(1),
        $each: {
          lastName: {required, maxLength: maxLength(50)},
          firstName: {required, maxLength: maxLength(50)},
          phone: {required, minLength: minLength(12), maxLength: maxLength(12)},
          email: {required, email}
        }
      }
    }
  },
}
</script>
<style>
  .b-toast, #minToast {
    max-width: initial !important;
  }
</style>
